const AirlineList = () => import("@/views/airline/AirlineList.vue")
const AirlineChange = () => import("@/views/airline/AirlineChange.vue")
const AirlineOnboarding = () => import("@/views/airline/AirlineOnboarding.vue")
const AirlineRequestList = () => import("@/views/airline/request/AirlineRequestList.vue")
const AirlineRequestDetail = () => import("@/views/airline/request/AirlineRequestDetail.vue")
const AirlineQuoteList = () => import("@/views/airline/quote/AirlineQuoteList.vue")
const AirlineQuoteForm = () => import("@/views/airline/quote/AirlineQuoteForm.vue")
const AirlineQuoteDetail = () => import("@/views/airline/quote/AirlineQuoteDetail.vue")
const AirlineMessages = () => import("@/views/Messages.vue")
const AirlineShipments = () => import("@/views/Shipments.vue")
const AirlineShipmentDetails = () => import("@/views/ShipmentDetails.vue")
const AirlineContracts = () => import("@/views/airline/contract/AirlineContractList.vue")
const Notifications = () => import("@/views/Notifications.vue")


const airline_routes = [
  {
    path: '',
    redirect: '/dashboard',
  },
  {
    path: 'notifications',
    name: 'AirlineNotifications',
    component: Notifications,
    props: route => ({params: route.query}),
    meta: {requiresAuth: true}
  },
  {
    path: 'messages',
    name: 'AirlineMessages',
    component: AirlineMessages,
    props: route => ({params: route.query}),
    meta: {requiresAuth: true}
  },
  {

    path: 'shipments',
    meta: {breadcrumb: 'Charterer Shipments'},
    children: [
      {
        path: '',
        name: 'AirlineShipments',
        component: AirlineShipments,
        props: route => ({params: route.query}),
        meta: {breadcrumb: false},
      },
      {
        path: ':pk',
        name: 'AirlineShipmentDetails',
        component: AirlineShipmentDetails,
        props: route => ({params: route.query, pk: route.params.pk}),
        meta: {breadcrumb: 'Shipment Details'},
      },
    ]
  },
  {
    path: 'contracts',
    name: 'AirlineContracts',
    component: AirlineContracts,
    props: route => ({params: route.query}),
    meta: {requiresAuth: true}
  },
  {
    path: 'request',
    meta: {breadcrumb: 'Charter Request'},
    children: [
      {
        path: '',
        name: 'AirlineRequestList',
        component: AirlineRequestList,
        props: route => ({params: route.query}),
        meta: {breadcrumb: false},
      },
      {
        path: ':pk',
        name: 'AirlineRequestDetail',
        component: AirlineRequestDetail,
        props: route => ({params: route.query, pk: route.params.pk}),
        meta: {breadcrumb: 'Detail'},
      },
    ],
  },
  {
    path: 'quote',
    meta: {breadcrumb: 'Quote'},
    children: [
      {
        path: '',
        name: 'AirlineQuoteList',
        component: AirlineQuoteList,
        props: route => ({params: route.query}),
        meta: {breadcrumb: false},
      },
      {
        path: 'form/:requestId/:pk?',
        name: 'AirlineQuoteForm',
        component: AirlineQuoteForm,
        props: route => ({params: route.query, requestId: route.params.requestId, pk: route.params.pk}),
        meta: {breadcrumb: 'Form'},
      },
      {
        path: ':pk',
        name: 'AirlineQuoteDetail',
        component: AirlineQuoteDetail,
        props: route => ({params: route.query, pk: route.params.pk}),
        meta: {breadcrumb: 'Detail'},
      }
    ]
  },
  {
    path: 'list',
    name: 'AirlineList',
    component: AirlineList,
    props: route => ({params: route.query})
  },
  {
    path: 'onboarding',
    name: 'AirlineOnboarding',
    component: AirlineOnboarding,
    props: route => ({params: route.query})
  },
  {
    path: ':pk',
    name: 'AirlineChange',
    component: AirlineChange,
    props: route => ({params: route.query, pk: route.params.pk})
  }
]

export default airline_routes
